// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyCreateWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingType, PropertyType, UserPropertyCreateResponseWebDto } from '../..';

interface CreateParams {
  customerId?: string;
  fullAddress: string;
  includeWebAnalytics?: boolean;
  listingType: ListingType;
  numUnits?: number;
  propertyType: PropertyType;
  unitNumber?: string;
}

export const RentalManagerUserPropertyCreateWebApiHandler_create_Path = '/api/web/v1/users/properties/create';

/**
 * Create a property for the user
 * @deprecated
 */
export const RentalManagerUserPropertyCreateWebApiHandler_create = (getParams: CreateParams, client = getClient()) => {
  return httpFrontEndRequest<CreateParams, never, UserPropertyCreateResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyCreateWebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
